/**************************************************
 * Nombre:       Dialogo_Reserva
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import '@splidejs/react-splide/css';
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Reserva_Datos from "../Formularios/Formulario_Reserva_Datos";
import {Close} from "@mui/icons-material";
import {theme} from "../../Tema";
import {useRef, useState} from "react";
import {adaptador_habitacion_mas_reserva} from "../Adaptadores/adaptador_habitacion_mas_reserva";
import {obtenerValorReserva} from "../../CodigoNegocio/obtenerValorReserva";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../Recursos/logo_oscuro.png'
import {FECHACHECKIN, FECHACHECKOUT, ORIGENESRESERVAS} from "../../Modulo_Motor_Reservas/Constantes";
import {obtenerFechaEstandarCheckIn} from "../../Modulo_Motor_Reservas/Funciones/obtenerFechaEstandarCheckIn";
import {obtenerFechaEstandarCheckOut} from "../../Modulo_Motor_Reservas/Funciones/obtenerFechaEstandarCheckOut";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import Formulario_Reserva_Cantidad from "../Formularios/Formulario_Reserva_Cantidad";
import {obtenerHabitacionesDisponibles} from "../../Modulo_Motor_Reservas/Funciones/obtenerHabitacionesDisponibles";
import Tarjeta_Habitaciones_Reserva from "../Tarjetas/Tarjeta_Habitaciones_Reserva";
import {obtenerNumNoches} from "../../Modulo_Motor_Reservas/Funciones/obtenerNumNoches";
import paises from '../../Utilidades/Indicativos.json'
import {irUrl} from "../../Utilidades/irUrl";
import {iniciarChatWass} from "../../Utilidades/iniciarChatWass";
import {WASS} from "../../Constantes";


const Dialogo_Reserva = ({datos, cerrar, realizado, open}) => {
    const refe = useRef()
    const {
        props,
        obtenerEntidad,
    } = useFormulario({valoresDefecto: {fechaCheckOut: new Date().getTime() + 1000 * 60 * 60 * 20}})
    const {Cargador, Avisos, iniciarCarga, terminar, nuevoAviso} = useCargador({logoRedondo: logo, funcionUno: cerrar})
    const [habitaciones, setHabitaciones] = useState([])
    const [cargando, setCargando] = useState(false)
    const [seConsulto, setSeConsulto] = useState(false)
    const [entidad, setEntidad] = useState({})
    const [seleccionada, setSeleccionada] = useState({})

    const subirReserva = async () => {


        let entidad = await obtenerEntidad()
        entidad = adaptador_habitacion_mas_reserva({reserva: entidad, habitacion: seleccionada})
        let numNoches = obtenerNumNoches({fechaCheckIn: entidad.fechaCheckIn, fechaCheckOut: entidad.fechaCheckOut})
        entidad.valor = obtenerValorReserva({entidad: entidad, habitacion: seleccionada, numNoches: numNoches})
        entidad.valorSaldo = entidad.valor
        entidad.numNoches = numNoches
        iniciarCarga('Subiendo datos')
        if (!entidad.id) {
            entidad.fecha = new Date().getTime()
        }


        let indicativo = paises.filter((it) => it.nameES === entidad.indicativo)
        entidad.indicativo = indicativo


        if (!entidad.estado) {
            entidad.estado = 'Potencial'
        }

        if (!entidad.origen) {
            entidad.origen = ORIGENESRESERVAS[1]
        }

        entidad[FECHACHECKIN] = obtenerFechaEstandarCheckIn(entidad[FECHACHECKIN])
        entidad[FECHACHECKOUT] = obtenerFechaEstandarCheckOut(entidad[FECHACHECKOUT])

        let result = await guardarDoc('reservas', entidad)
        if (result.res) {
            // await enviarNotificacion(entidad)
            terminar({aviso: 'Reserva realizada, pronto nos comunicaremos contigo'})

        } else {
            terminar({aviso: 'Algo inesperado paso! datos no subidos', variante: 'error'})
        }
    }


    const consultar = async () => {


        setCargando(true)
        let entidad = await obtenerEntidad()
        setEntidad(entidad)
        let habitaciones = await obtenerHabitacionesDisponibles({
            fechaCheckIn: entidad.fechaCheckIn,
            fechaCheckOut: entidad.fechaCheckOut
        })

        let habs = habitaciones.filter((c) => c.maximoAdultos >= entidad.numAcompanantes)
        console.log(habs)
        setHabitaciones(habs)
        if (habs[0]) {
            setSeleccionada(habs[0])
        }

        setCargando(false)
        setSeConsulto(true)

    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{mt: 0}}
        >

            <Cargador/>

            <Avisos/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', p: 2, zIndex: 2}}>
                <IconButton
                    onClick={() => cerrar()} sx={{backgroundColor: theme.palette.primary.main}}>
                    <Close sx={{fill: '#fff'}}/>
                </IconButton>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -2}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{p: 3}}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Formulario_Reserva_Cantidad props={props}/>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 3}}>
                        <Button
                            onClick={() => consultar()}
                            loading={cargando}
                        >Consultar</Button>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            spacing={2}
                        >

                            {habitaciones.map((it, index) => {
                                return (
                                    <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                                        <Tarjeta_Habitaciones_Reserva item={it} entidad={entidad}
                                                                      seleccionada={seleccionada}
                                                                      setSeleccionada={setSeleccionada}/>
                                    </Grid>
                                )
                            })}

                            {habitaciones.length === 0 && seConsulto &&

                                <>
                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-start', px: 2}}>
                                        <Typography sx={{textAlign: 'center'}}>No hay habitaciones disponibles para esta
                                            fecha, intenta con otras fechas o habla con recepcion</Typography>
                                    </Grid>


                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                        <Button
                                            onClick={() => iniciarChatWass({numero: WASS})}
                                        variant={'outlined'}
                                        >Hablar con Recepcionista</Button>
                                    </Grid>

                                </>
                            }

                        </Grid>
                    </Grid>

                    {seleccionada.id &&

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                            <Formulario_Reserva_Datos props={props}/>
                        </Grid>
                    }

                </Grid>
            </Grid>

            {seleccionada.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2, mb: 4}}>
                    <Button
                        onClick={() => subirReserva()}
                        variant={'contained'} color={'primary'}>Realizar Reserva</Button>
                </Grid>

            }


        </Grid>
    )

}
export default Dialogo_Reserva
